export const getCountyFlagLink = (countryCode: string) => {
  return `https://storage.googleapis.com/wingspan-public-content/flags/${countryCode}.svg`;
};
